const INPUT_SEARCH_TITLE = "EN Изчислете ГИ / ГТ на Вашата Храна"
const INPUT_SEARCH_PLACEHOLDER = "EN Търси по име на храна..."
const GLYCEMIC_INDEX_OF = "EN Гликемичен индекс на"
const GLYCEMIC_LOAD_OF = "EN Гликемичен товар на"
const PER_SERVING_OF = "EN за порция от"
const GRAM = "EN гр"
const TABS_SECTION_TITLE = "EN Намерете подходяща за Вас Храна"
const GLYCEMIC_INDEX_TAB = "EN Гликемичен Индекс"
const GLYCEMIC_LOAD_TAB = "EN Гликемичен Товар"
const FOODS_WITH_GLYCEMIC_INDEX_BETWEEN = "EN Храни с гликемичен индекс между"
const FOOD_SEARCH_BUTTON = "EN Търси подходяща за мен храна"
const FOODS_WITH_GLYCEMIC_LOAD_BETWEEN = "EN Храни с гликемичен индекс между"
const FOOD_DRINK = "EN Храна/Напитка"
const GI = "EN ГИ"
const GLUCOSE = "EN глюкоза"
const PORTION = "EN порция"
const GL = "EN ГТ"
const LOW_GLYCEMIC_INDEX = "EN Нисък гликемичен индекс"
const AVERAGE_GLYCEMIC_INDEX = "EN Среден гликемичен индекс"
const HIGH_GLYCEMIC_INDEX = "EN Висок гликемичен индекс"
const CARBOHYDRATES = "EN Въгл."
const CALORIE_CALCULATOR_TITLE = "EN Калориен Калкулатор"
const CALORIE_CALCULATOR_DESCRIPTION =
  "EN Изчислете препоръчителните за Вас калории за деня."
const MY_UNITS = "EN Мерни единици:"
const IMPERIAL = "EN Имперична система"
const METRIC = "EN Метрична система"
const WHAT_IS_YOUR_GENDER = "EN Вашият пол:"
const MALE = "EN Мъж"
const FEMALE = "EN Жена"
const WHAT_IS_YOUR_WEIGHT = "EN Вашето тегло:"
const KG = "EN кг"
const LB = "EN паунд"
const WHAT_IS_YOUR_HEIGHT = "EN Вашата височина:"
const SM = "EN см"
const WHAT_IS_YOUR_AGE = "EN Вашата възраст:"
const WHICH_SENTENCE_BEST_DESCRIBES_YOUR_DAILY_ACTIVITY_LEVEL =
  "EN Кое изречения най-добре описва физическата Ви активност през работно време:"
const SEATED_MOST_OF_THE_DAY =
  "EN В седящо положение съм през по-голямата част от времето (например работник в офис; шофьор на такси)"
const STANDING_ABOUT_HALF_THE_TIME =
  "EN В седящо положение съм през половината част от времето(например преподавател)"
const WALKING_ABOUT_HALF_THE_TIME =
  "EN През половина време съм в движение (например супервайзор, сервитьор)"
const CONSTANTLY_ON_THE_MOVE =
  "EN Постоянно съм в движение (например доставчик)"
const WHICH_MATCHES_YOUR_LEVEL_OF_PHYSICAL_ACTIVITY =
  "EN Което съответства на Вашето ниво на физическа активност през свободното Ви време:"
const GET_RESULTS_BUTTON = "EN ИЗЧИСЛИ"
const DAILY_RECOMMENDED_CALORIES = "EN Вашата дневна калорийна нужда:"
const RECOMMENDED_TEXT =
  "EN Въз основа на информацията, която сте предоставили, това са препоръчителните калории за здравословно тегло"
const TRY_CALCULATOR_AGAIN_BUTTON = "EN ОПИТАЙ КАЛКУЛАТОРА ОТНОВО"
const KG_POPUP =
  "EN Въведената стойност е извън позволения обхват от стойностти 30кг – 220кг"
const LB_POPUP =
  "EN Въведената стойност е извън позволения обхват от стойностти 66паунд – 485паунд"
const FEET = "EN фут"
const SM_POPUP =
  "EN Въведената стойност е извън позволения обхват отстойностти 110 cm – 220 cm"
const FEET_POPUP =
  "EN Въведената стойност е извън позволения обхват отстойностти 3.6 фут – 7.22 фут"
const YEARS = "EN год."
const YEARS_POPUP =
  "EN Въведената стойност е извън позволения обхват от стойностти 18 г – 110 г"
const SLIDER_VALUE_0 = "EN Занимавам се с леки физически дейности"
const SLIDER_VALUE_0_TEXT =
  "EN например бавно ходене (разходка), леко разтягане, седене и игра с деца или леко почистване."
const SLIDER_VALUE_1 = "EN Занимавам се с умерени физически дейности"
const SLIDER_VALUE_1_TEXT =
  "EN например бърза разходка, бавно колоездене в свободното време, тенис на маса, свободно плуване, тай чи или тежко почистване."
const SLIDER_VALUE_2 = "EN Участвам в енергични физически дейности"
const SLIDER_VALUE_2_TEXT =
  "EN напр. аеробика, джогинг или футбол, тенис, баскетбол, плуване в обиколка или други състезателни спортове."

// //Header end
const SECTION_TITLE = "EN Изчислете Вашият Индекс на Телесната Маса"
const KG_CM = "EN кг / см"
const LBS_INCH = "EN фунт / инч"
const WEIGHT = "EN Тегло"
const HEIGHT = "EN Височина"
const KG_BMI = "EN (кг)"
const CM = "EN (см)"
const LBS = "EN Фунт"
const INCH = "EN Инч"
const CALCULATE_BUTTON = "EN Изчисли Сега"
const RECOMMENDATION_UNDER_18_5 =
  "EN Вие попадате в категорията на поднорменото тегло. Това може да крие риск за Вашето здраве. Обърнете се към личния си лекар или специалист за проблеми с теглото, с които може да обсъдите проблема и да вземете мерки навреме."
const RECOMMENDATION_OVER_18_5_UNDER_24_9 =
  "EN Вие попадате в категорията на нормално телесно тегло. Това е чудесно, но ако имате натрупване на мазнини в областта на корема, обсъдете с личния лекар или еднокринолог този проблем, за да вземете мерки навреме."
const RECOMMENDATION_OVER_24_9_UNDER_29_9 =
  "EN Вие попадате в категорията на наднорменото тегло. Това може да крие риск за Вашето здраве, особено ако имате натрупване на мазнини в областта на корема. Обърнете се към личния си лекар, специалист за проблеми с теглото или ендокринолог, с които може да обсъдите проблема и да вземете мерки навреме."
const RECOMMENDATION_OVER_29_9_UNDER_34_9 =
  "EN Вие попадате в категорията на затлъстяване Iст. Това крие риск за Вашето здраве и трябва да вземете мерки. Обърнете се към личния си лекар, специалист за проблеми с теглото или ендокринолог, с които може да обсъдите проблема и да вземете мерки навреме."
const RECOMMENDATION_OVER_34_9_UNDER_39_9 =
  "EN Вие попадате в категорията на затлъстяване IIст. Това крие сериозен риск за Вашето здраве и трябва да вземете мерки. Обърнете се към личния си лекар, специалист за проблеми с теглото или ендокринолог, с които може да обсъдите проблема и да вземете мерки навреме."
const RECOMMENDATION_OVER_39_9 =
  "EN Вие попадате в категорията на затлъстяване IIIст. Това крие много сериозен риск за Вашето здраве и трябва да вземете мерки обезателно. Обърнете се към личния си лекар, специалист за проблеми с теглото или ендокринолог, с които може да обсъдите проблема и да вземете мерки навреме."
const CONTACT_WITH_EXPERT = "EN Свържете се със специалист"
const CONTACT_WITH_EXPERT_URL_I = "/contacts"
const CONTACT_WITH_EXPERT_URL_II = "/blog"
const MORE_ADVICES_BUTTON = "EN Още съвети за здравословен живот"
const ADVICES_FOR_HEALTHY_LIFE_BUTTON = "EN Съвети за здравословен живот"

// 404

const PAGE_NOT_FOUND = "EN 404 - Не е намерена тази страница"
const PAGE_NOT_HOME_PAGE = "EN Начална страница"

// First Steps

const FIRST_STEPS_PLS_VAL_EMAIL = "EN Моля въведете валиден емайл адрес"
const FIRST_STEPS_REQ_FLD = "EN Това поле е задължително"
const FIRST_STEPS_PLS_ACPT_TERMS =
  "EN Моля съгласете се с условията за поверителност"

// First Steps - Response Modal -> RM

const FIRST_STEPS_RM_TNX_BETA =
  "EN Благодарим Ви, че се включихте в нашата бета версия. Нашият екип ще Ви изпрати детайли за безплатната консултация."
const FIRST_STEPS_RM_TNX_MSG =
  "EN Благодарим за съобщението. Нашият екип ще се свърже с Вас."

// First Steps - Form

const FIRST_STEPS_FORM_PRIVACY_POLICY = "EN Политиката за поверителност"
const FIRST_STEPS_FORM_READ_AND_AGREE = "EN Прочетох и приемам"
const FIRST_STEPS_FORM_SUBMIT = "EN Изпрати запитването"
const FIRST_STEPS_FORM_UR_EMAIL = "EN Вашият имейл*"
const FIRST_STEPS_FORM_TERMS = "EN Общите условия"
const FIRST_STEPS_FORM_UR_NAME = "EN Вашето име*"
const FIRST_STEPS_FORM_FS = "EN Първи стъпки"
const FIRST_STEPS_FORM_YES_SUBSCRIBE =
  "EN Да, искам да се абонирам за Dianurse бюлетина"
const FIRST_STEPS_FORM_AND = "EN и"

// Index (Home Page)

// Index - Calculators Info Section (Desc)
const INDEX_CALC_INFO_FOUR_FREE = "EN Имаме 4 напълно"
const INDEX_CALC_TOOLS_FOR_HELP = "EN инструмента във Ваша помощ"
const INDEX_CALC_INFO_FREE = "EN БЕЗПЛАТНИ"
const INDEX_CALC_TOOLS_DESC =
  "EN Инструментите са изготвени от нашите здравни специалисти. Ще Ви предложат важни съвети и насоки, за да Ви помогнат да водите по-добър, по-здравословен и пълноценен живот. Подходящи са и за хора без диабет."

// Index - Healthy Life Section
const INDEX_HLTH_LIFE_FIRST_STEPS_BTR_LIFE = "EN Първи стъпки за по-добър живот"
const INDEX_HLTH_LIFE_HEALTHY_LIFE = "EN пълноценен живот?"
const INDEX_HLTH_LIFE_U_WANT_LEAD = "EN Искате да водите"
const INDEX_HLTH_LIFE_DESC =
  "EN Ако сте с диагноза диабет, предиабет или сте предразположени към тях, нашите лекари и консултанти са подготвили ръководство, което ще Ви помогне по пътя за постигане на здрав и пълноценен живот. Предоставената информация е напълно безплатна и е изготвена от водещи специалисти в областта."

// Index - Calculators Info Section (Cards)
const INDEX_CALC_INFO_WHATS_BEST_WEIGHT =
  "EN Как да разберем какво е идеалното ни телесно тегло"
const INDEX_CALC_INFO_DAILY_CAL_INTAKE =
  "EN Как да изчислите дневните си калорийни нужди."
const INDEX_CALC_INFO_FOOD_U_NEED =
  "EN Изберете храната си спрямо Вашите нужди."
const INDEX_CALC_INFO_FOOD_NAV_II = "EN Хранителен навигатор II"
const INDEX_CALC_INFO_FOOD_NAV_I = "EN Хранителен навигатор I"
const INDEX_CALC_INFO_GLIC_INDEX =
  "EN Проверете гликемичния индекс и товар на храната си"
const INDEX_CALC_INFO_CAL_CALC = "EN Калориен калкулатор"
const INDEX_CALC_INFO_SEE_MORE = "EN Виж още"
const INDEX_CALC_INFO_BMI = "EN Индекс на телесна маса"

// Index - Review Slider
const INDEX_CALC_REWIEW_URL_I =
  "EN istoriya-za-diabet-naslazhdavai-se-na-zhivota-si"
const INDEX_CALC_REWIEW_URL_II =
  "EN obrazovai-se-i-se-prigotvi-da-promenish-celiya-si-zhivot"
const INDEX_CALC_REWIEW_URL_III = "EN diabett-prez-pogleda-na-dietolog"
const INDEX_CALC_REWIEW_YI = "EN Yi Ting е на 34 години, от Гватемала."
const INDEX_CALC_REWIEW_YI_STORY =
  "EN Диабетът променя живота й. Прави я по-силна. Тя започва да обича себе си все повече и повече. Прочетете нейните съвети!"
const INDEX_CALC_REWIEW_JAY = "EN Джей е на 42 години, от Литъл Рок."
const INDEX_CALC_REWIEW_JAY_STORY =
  "EN Нейната главна цел е да увеличи информираността относно диабета. Разберете защо това е толкова важно."
const INDEX_CALC_REWIEW_IVET =
  "EN Ивет Пилева е доктор и диетолог с голям опит особено при хора с диабет."
const INDEX_CALC_REWIEW_IVET_STORY =
  "EN Доктор Пилева ни дава съвети за балансиран начин на живот."

// Index - Review Wrapper
const INDEX_CALC_STORIES = "EN Истории на наши потребители"
const INDEX_BLOG_WRPR_HLP_FR_U = "EN Избрано в помощ за вас"

// Index - For Diabetes Section

const INDEX_DIABETES_DIAGNOSED_COUNT = "EN 1.7 милиона"
const INDEX_DIABETES_AFFECTED_COUNT = "EN 422 милиона"
const INDEX_DIABETES_SUGAR_DEAD = "EN 2.2 милиона"
const INDEX_DIABETES_DEAD_COUNT = "EN 1.6 милиона"
const INDEX_DIABETES_DIAGNOSED = "EN човека се диагностицират всяка година"
const INDEX_DIABETES_AFFECTED = "EN хора страдат от диабет"
const INDEX_DIABETES_SUGAR = "EN човека са починали от висока кръвна захар"
const INDEX_DIABETES_DESC = "EN За диабета в цифри през годините"
const INDEX_DIABETES_DEAD = "EN са директните смъртни случаи от диабет"

// Index - Hero Section

const INDEX_HERO_NEW_DIAGNOSE = "EN новодиагностицирани диабетици"
const INDEX_HERO_HERE_TO_HELP = "EN Тук сме, за да помагаме на"
const INDEX_HERO_FIRST_STEPS = "EN ПЪРВИ СТЪПКИ"
const INDEX_HERO_FREE_GUIDE = "EN безплатно онлайн ръководство"

// Header

const HEADER_CALCULATORS = "EN КАЛКУЛАТОРИ"
const HEADER_DIABETIC = "EN ЗА ДИАБЕТИЦИ"
const HEADER_DOCTORS = "EN ЗА ЗДРАВНИ СПЕЦИАЛИСТИ"
const HEADER_MAIN = "EN НАЧАЛО"
const HEADER_BLOG = "EN БЛОГ"

// Footer

const FOOTER_ABOUT_COMNY = "EN За компанията"
const FOOTER_ABOUT_US = "EN За нас"
const FOOTER_CARIERS = "EN Кариера"
const FOOTER_CONTACT_US = "EN Връзка с нас"
const FOOTER_HELP_CENTRE = "EN Център за помощ"
const FOOTER_BLOG = "EN Блог"
const FOOTER_HELP = "EN Помощ"
const FOOTER_FAQ = "EN FAQ"
const FOOTER_LEGAL = "EN Правни"
const FOOTER_TERMS = "EN Общи условия"
const FOOTER_PRIVACY = "EN Политика за поверителност"
const FOOTER_COOKIES = "EN Политика за бисквитките"
const FOOTER_SERVICES = "EN Услуги"
const FOOTER_TOOLS = "EN Инструменти"
const FOOTER_DOC_NETWORK = "EN Докторска мрежа"
const FOOTER_DIABETICS = "EN Диабетици"
const FOOTER_PODCASTS = "EN Подкасти"

// home Consultation Desc

const HOME_CONSULT_DESC_SPEC_OFFER = "EN СПЕЦИАЛНО ПРЕДЛОЖЕНИЕ"
const HOME_CONSULT_DESC_FREE = "EN Безплатна"
const HOME_CONSULT_DESC_CONSULTATION = "EN консултация"
const HOME_CONSULT_DESC_MED_PRO = "EN с медицински специалист"
const HOME_CONSULT_DESC_TEXT =
  "EN Харесва ли Ви това което видяхте? Даваме Ви възможност да се включите в нашата отворена бета версия и да получите безплатна консултация от лекари и здравни специалисти."
const HOME_CONSULT_DESC_ONEHUND_PRO = "EN 100% сигурност"
const HOME_CONSULT_DESC_NO_SPAM = "EN БЕЗ СПАМ"
const HOME_CONSULT_DESC_ANON = "EN Запази анонимноста си"
const HOME_CONSULT_DESC_PDF = "EN Получаваш PDF ръководство"

// For Diabetics

// For Diabetics - Help Section

const DIABETICS_HLP_SECTION_HEALTH_PRO =
  "EN Намерете перфектния здравен специалист, без значение къде живеете"
const DIABETICS_HLP_SECTION_TEXT =
  "EN Ако скоро сте били диагностицирани с диабет, вероятно все още сте объркани, нали? Търсенето на здравен специалист, който може винаги да Ви даде адекватна и 100% грижа, в повечето случаи е изнервящо и изисква време. Ние решаваме този проблем за Вас."
const DIABETICS_HLP_SECTION_SIGN_UP = "EN Запиши се"

// For Diabetics - How it Works

const DIABETICS_HIW_EASY_STEPS =
  "EN С няколко прости стъпки може да достигнете до стотици здравни специалисти от целия свят. Променете живота си още днес."
const DIABETICS_HIW_ALWAYS_IN_CONTACT = "EN 1. Винаги в контакт"
const DIABETICS_HIW_AIC_TEXT =
  "EN Бъдете винаги в контакт със здравните си специалисти за единични или регулярни консултации, както и за получаване на напътствия във вземането на важни решения за управление на диабета Ви."
const DIABETICS_HIW_PIC_A_PRO = "EN 2. Избор на здравен специалист"
const DIABETICS_HIW_PAP_TEXT =
  "EN Потърсете здравен експерт извън Вашето населено място, в случай че не сте доволни от местните специалисти или те просто липсват. Създайте Ваш екип от специалисти, с който лесно да резервирате консултации и да общувате."
const DIABETICS_HIW_TRANSPARANCY = "EN 3. Прозрачност и контрол"
const DIABETICS_HIW_DIABETICS_HIW_TRANSPARANCY_TEXT =
  "EN Разгледайте профилите на нашите здравни специалисти. Разгледайте мненията за тях, както и таксите им за консултация/преглед. Заплащайте само това от което се нуждаете."
const DIABETICS_HIW = "EN Как Работи"

// For Diabetics - Online Consultation

const DIABETICS_OC_EASY_SECURE_FAST =
  "EN Лесно, сигурно и бързо записване на час за онлайн консултация"
const DIABETICS_OC_ESF_TEXT =
  "EN През предпочитаната от Вас платформа. Пропуснете опашките за чакане при здравен специалист и получете видео консултация когато и където желаете."
const DIABETICS_OC_EASY_ACCESS = "EN Лесен достъп"
const DIABETICS_OC_EA_TEXT =
  "EN През най-съвременни технологии за сигурност. Управлявайте консултациите си с лекота и при пълен контрол единствено и само от Ваша страна."
const DIABETICS_OC_SYNC = "EN Винаги в синхрон"
const DIABETICS_OC_SYNC_TEXT =
  "EN Изпратете съобщение, за да получите своевременен съвет от Вашия здравен специалист. Използвайте видео прегледите и получавайте известия в реално време."
const DIABETICS_OC_SIGN_UP = "EN Запиши се"

// For Diabetics - APP Section

const DIABETICS_APP_GET_TO_KNOW = "EN Опознайте нашето приложение"
const DIABETICS_APP_DESC =
  "EN Лесен достъп, 24/7 достъп, сигурно плащане и множество ресурси"
const DIABETICS_APP_EASY = "EN Лесно"
const DIABETICS_APP_EASY_TEXT =
  "EN Потърсете предпочитан здравен специалист и резервирайте визита чрез няколко лесни кликвания. Без значение къде избрания от Вас здравен специалист практикува."
const DIABETICS_APP_CONVENIENT = "EN Удобно"
const DIABETICS_APP_CONVENIENT_TEXT =
  "EN Резервирайте визита в най-удобното за Вас време. Без необходимост да пътувате до и чакате пред кабинета на избрания от Вас здравен специалист."
const DIABETICS_APP_TRANSPARENT = "EN Прозрачно"
const DIABETICS_APP_TRANSPARENT_TEXT =
  "EN Информирайте се подробно за експертизата, рейтинга и цените на здравния специалист преди да резервирате."
const DIABETICS_APP_SECURE = "EN Надеждно"
const DIABETICS_APP_SECURE_TEXT =
  "EN Изберете от нашите сертифицирани специалисти, чийто сертификати и лицензии са специално проверени от нас за Вас."
const DIABETICS_APP_NO_CASH = "EN Без кеш и без усилие"
const DIABETICS_APP_NO_CASH_TEXT =
  "EN Свържете Вашата карта към приложението Dianurse и се разплащайте без касово. Получете разписка с всички детайли по имейл."
const DIABETICS_APP_INDV_SEG = "EN Индивидуализирани препоръки"
const DIABETICS_APP_INDV_SEG_TEXT =
  "EN Вашият екип от здравни специалисти ще Ви предложи първоначален план за управление на диабета Ви и регулярно ще следи прогреса Ви, като ще променя плана Ви, съобразявайки с Вашето състояние и особености.."

// For Diabetics - Newsletter

const DIABETICS_NEWSLTTR_FREE_TIPS = "EN Безплатни съвети"
const DIABETICS_NEWSLTTR_HOW_TO_PICK =
  "EN Разберете как да подобрите вашият индекс на телесна маса с"
const DIABETICS_NEWSLTTR_FREE = "EN БЕЗПЛАТНИ"
const DIABETICS_NEWSLTTR_TIPS = "EN съвети от здрави експерти."
const DIABETICS_NEWSLTTR_SUBSCRIBE = "EN Абониране"

// For Health Coaches

// For Health Coaches - Header section

const HLTH_COACH_HEADER_PROFIT = "EN Печелете от онлайн консултации чрез нас"
const HLTH_COACH_HEADER_DESC =
  "EN Заявете своя ранен достъп до платформата, даваща достъп до хиляди пациенти с диабет. Разширете обхвата на вашата работа. Видео консултации, анализи, инструменти за оптимизация на работата и още много възможности на платформа от световно ниво."
const HLTH_COACH_HEADER_FREE_ACS = "EN БЕЗПЛАТЕН ДОСТЪП"

// For Health Coaches - Features

const HLTH_COACH_FEAT_NEW_PACI = "EN Нови пациенти"
const HLTH_COACH_FEAT_REACH_WORLD =
  "EN Достигнете до нови пациенти по целият свят."
const HLTH_COACH_FEAT_AUTO_WORK = "EN Автоматизация на работата"
const HLTH_COACH_FEAT_FASTER_BETTER =
  "EN Вършете по-бързо и качествено работата си."
const HLTH_COACH_FEAT_ONLINE = "EN Онлайн консултации"
const HLTH_COACH_FEAT_SCHEDULE =
  "EN Създайте график и контролирайте притока на пациенти към вас"
const HLTH_COACH_FEAT_TRUE_FEEDBACK = "EN Истинска обратна връзка"
const HLTH_COACH_FEAT_RATE =
  "EN Получете оценката от вашите пациенти сигурно и анонимно"

// For Health Coaches - Training

const HLTH_COACH_TRAINING_ONLINE_COUNSULTATION =
  "EN Силата на онлайн консултациите"
const HLTH_COACH_TRAINING_INCOME = "EN Повишете приходите си"
const HLTH_COACH_TRAINING_INCOME_TEXT =
  "EN Може да провеждате онлайн консултации с пациенти от целият свят и сами да определяте цената за това."
const HLTH_COACH_TRAINING_SCHEDULE = "EN Бъдете организирани"
const HLTH_COACH_TRAINING_SCHEDULE_TEXT =
  "EN Работата с много клиенти може да е трудна, но нашите инструменти са създадени, за да правят работата ви по-лесна и бърза."
const HLTH_COACH_TRAINING_CONSULTATION = "EN Онлайн консултацииs"
const HLTH_COACH_TRAINING_CONSULTATION_TEXT =
  "EN Може да водите онлайн консултации с индивудални пациенти, вие определяте цената и свободното си време"

// For Health Coaches - Help Section

const HLTH_COACH_HELP_HELP_PPL = "EN Помагайте на повече хора без усилия."
const HLTH_COACH_HELP_REACH_THE_WORLD =
  "EN Достигнете до целият свят без усилия, използвайте най-съвременните инструменти, печелете повече пари."
const HLTH_COACH_HELP_LEARN_MORE = "EN Научи още"
const HLTH_COACH_HELP_PROFIT =
  "EN Увеличих месечните си доходи за кратък период и намерих повече време за нещата, които обичам."
const HLTH_COACH_HELP_DR_HRISTO = "EN д-р Христо Иванов"
const HLTH_COACH_HELP_DOC = "EN кардиолог"

// For Health Coaches - Prices

const HLTH_COACH_PRICE_TALK_IN_NUM = "EN Нека да поговорим в цифри?"
const HLTH_COACH_PRICE_TIN_TEXT =
  "EN Развивайте потенциала си и помогнете на хиляди хора по света. Елиминирайте преградите на кабинета. Вие избирате с кого и как да работите. Печелете пари от всяка точка на света."
const HLTH_COACH_PRICE_PRECENT_I = "EN 76%"
const HLTH_COACH_PRICE_I_TEXT =
  "EN от пациентите вече се интересуват от използването на решения за теле-медицина след настъпването на Covid-19 пандемията"
const HLTH_COACH_PRICE_PRECENT_II = "EN 70%"
const HLTH_COACH_PRICE_II_TEXT =
  "EN от визитите при лекар са били отменени по време на Covid-19 пандемията"
const HLTH_COACH_PRICE_PRECENT_III = "EN 64%"
const HLTH_COACH_PRICE_III_TEXT =
  "EN от доставчиците на медицински услуги възнамеряват да въведат теле-медицински решения в практиките си"
const HLTH_COACH_PRICE_PRECENT_IV = "EN Над 60%"
const HLTH_COACH_PRICE_IV_TEXT =
  "EN от пациентите желаят да управляват хронично заболяване чрез теле-медицина"

// For Health Coaches - Features

const HLTH_COACH_KEY_FEATURES_KEY_FEATURES =
  "EN Ключови възможности на платформата"
const HLTH_COACH_KEY_FEATURES_ONLINE_CALENDAR = "EN Онлайн календар"
const HLTH_COACH_KEY_FEATURES_CAL_TEXT =
  "EN Организирайте прегледите и времето за консултации по най-добрия начин за Вас. Без пропуснати часове и застъпени прегледи. Ние имаме грижата."
const HLTH_COACH_KEY_FEATURES_YOU_ARE =
  "EN Дайте на пациентите си това, което им е нужно. Ако сте амбициозен професионалист в своята област, който желае да се развива в областта на телемедицината и да предлага качествена услуга на своите пациенти, станете част от екипа ни!"
const HLTH_COACH_KEY_FEATURES_YOU_ARE_TEXT = "EN Следвайте иновациите"
const HLTH_COACH_KEY_FEATURES_FOLLOW_INOVATIONS =
  "EN Профилът Ви в нашата платформа и организацията на работата в нея ще Ви осигурят възможност за онлайн консултации, които се доближават до реалния контакт с пациента, но ще Ви спестят време и усилия."
const HLTH_COACH_KEY_FEATURES_INOVATION_TEXT =
  "EN Вие сте лекар или специалист по здравни грижи"
const HLTH_COACH_KEY_FEATURES_WORK_FROM_HOME = "EN Работете от вкъщи"
const HLTH_COACH_KEY_FEATURES_TEXT =
  "EN Онлайн консултациите са възможност, която Ви позволява да работите откъдето Ви е удобно. Вече не е необходимо да чакате в трафика и да бързате за кабинета. Сега имате възможност да ги направите от вкъщи."

// Blog

const BLOG_NEW = "EN Най-нови блог постове"
const BLOG_MOST_READ = "EN Най-четени"
const BLOG_CATEGORIES = "EN категории:"

// BMI

const BMI_EMAIL_SCS = "EN Успешно изпратен имейл."
const BMI_EMAIL_INV = "EN Имейлът е невалиден."
const BMI_EMAIL_USD = "EN Този имейл вече е използван."
const BMI_BMI = "EN Индекс на Телесната маса"

const BMI_FEAT_URL_I = "EN /kakvo-e-itm-i-za-kakvo-mozhe-da-ni-posluzhi/"
const BMI_FEAT_URL_II = "EN /kak-da-razberem-kakvo-e-idealnoto-ni-teglo/"
const BMI_FEAT_URL_III = "EN /kak-da-razchitame-itm/"
const BMI_FEAT_URL_IV = "EN /primer-za-rabota-s-kalkulatora/"

// BMI - Header

const BMI_HEADER_MAIN_TEXT =
  "EN Научете всичко по темата за индекса на телесната маса направо от нашите здравни експерти – какво е, за какво ни служи, как да разберем какво е идеалното ни тегло, как да разчитаме изчисленията, какви са рисковете за здравето ни и кога този индикатор може да ни заблуди. И много още … "
const BMI_HEADER_MASS = "EN Изчислете Вашето идеално тегло"
const BMI_HEADER_CALC = "EN Изчислете Сега"

// BMI - Features

const BMI_FEAT_RES = "EN Полезни ресурси за "
const BMI_FEAT_MESURE = "EN измерване на индекса на телесна мазнина"
const BMI_FEAT_WHAT_IS_ITM = "EN Какво е ИТМ и за какво може да ни послужи?"
const BMI_FEAT_USE_EFECTIVE =
  "EN Разберете какво точно е ИТМ и как да го използвате ефективно."
const BMI_FEAT_READ_MORE = "EN прочети още"
const BMI_FEAT_PERFECT_WEIGHT = "EN Как да разберем какво е идеалното ни тегло?"
const BMI_FEAT_HOW_TO_ITM =
  "EN Как да разчитаме изчисленията на калкулатора? Има ли риск за здравето ни?"
const BMI_FEAT_ITM_FLAWS =
  "EN Какви са недостатъците на ИТМ калкулатора и кой не трябва да го използва?"
const BMI_FEAT_HOW_TO_USE = "EN Как да разчитаме ИТМ"
const BMI_FEAT_EXSAMPLE = "EN Пример за Работа с Калкулатора"
const BMI_FEAT_EXSAMPLE_EASY =
  "EN Вижте лесен пример как да използвате ИТМ калкулатора."

// Calorie Features Section

const CAL_CALC_FEAT_USEFULL = "EN Полезни ресурси за"
const CAL_CALC_FEAT_CAL_INTAKE =
  "EN Вашия калориен прием и как да изчислите колко калории са Ви нужни на ден"
const CAL_CALC_FEAT_WHAT_CAL = "EN Какво представляват калориите?"
const CAL_CALC_FEAT_LEARN_WHAT_CAL =
  "EN Разберете какво точно представляват калориите."
const CAL_CALC_FEAT_LEARN_MORE = "EN прочети още"
const CAL_CALC_FEAT_CAL_BURN =
  "EN Как тялото използва калориите и колко калории изгаря в покой?"
const CAL_CALC_FEAT_LEARN_CAL_BURN =
  "EN Научете колко калории се изгарят в покой и как да го изчислите."
const CAL_CALC_FEAT_HOW_MUCH_CAL = "EN Какви са ежедневните калорийни нужди?"
const CAL_CALC_FEAT_LEARN_HOW_MUCH_CAL =
  "EN Разберете кои са ежедневните калорийни нужди и защо е важно да знаете колко калории изразходвате на ден."
const CAL_CALC_FEAT_TYPES =
  "EN Важно ли е какви са източниците на калории или е достатъчно само да следите количеството, за да поддържате здравословно и оптимално тегло?"
const CAL_CALC_FEAT_SORCE =
  "EN Важно ли е какви са източниците на калории или е достатъчно само да следите количеството, за да поддържате здравословно и оптимално тегло?"
const CAL_CALC_FEAT_QAL =
  "EN Качеството е важно. Разберете как да поддържате здравословно и оптимално тегло като следите калориите и техните източници."

// MISC

const CAL_CALC_URL_I = "EN /kakvo-predstavlyavat-kaloriite/"
const CAL_CALC_URL_II =
  "EN /kak-tyaloto-izpolzva-kaloriite-i-kolko-kalorii-izgarya-v-pokoi/"
const CAL_CALC_URL_III = "EN /kakvi-sa-ezhednevnite-kaloriini-nuzhdi/"
const CAL_CALC_URL_IV =
  "EN /vazhno-li-e-kakvi-sa-iztochnicite-na-kalorii-ili-e-dostatchno-samo-da/"

const CAL_CALC_SUB_TEXT = "EN Изчислете калориите от които се нуждаете"
const CAL_CALC_TEXT =
  "EN Научете повече за калориите, какво представляват, колко трябва да приемате на ден, как организмите ни използват калориите, как да изчислим колко калории са ни необходими и много още …\n"
const CAL_CALC_TITLE = "EN Калориен калкулатор"
const NUTRITION_TEXT =
  "EN  Хранителният калкулатор е незаменим помощник в ежедневието. Ако имате колебания колко точно калории и от какво съотношение на макронутриентите се нуждаете за постигане на целите, консултирайте се със специалист. Не забравяйте, че освен тях изборът на подходящи и пълноценни хранителни вещества също е от значение."
const GL_CALC_SUB_TEXT = "EN Изчислете гликемичния индекс на Вашата храна."
const GL_CALC_TEXT =
  "EN Научете всичко за въглехидратите директно от нашите здравни експерти – какво представляват, как да изберете подходящите за Вас въглехидрати, какво е гликемичен индекс, как да изберете подходящата за Вас храна на базата на гликемичния индекс, и дали гликемичния индекс е най-подходящия начин да измервате количеството на въглехидратите, които приемате. Както и още много …\n"
const GL_CALC_TITLE = "EN Хранителен Навигатор ll"

// Nutrition

const NUTRITION_URI_I = "EN /kak-da-izpolzvate-khranitelniya-navigator/"
const NUTRITION_URI_II = "EN /kakvo-predstavlyavat-makronutrientite/"
const NUTRITION_URI_III =
  "EN /preporki-za-khranitelnite-sotnosheniya-na-makronutrientite/"
const NUTRITION_URI_IV = "EN /kak-da-izpolzvate-khranitelniya-navigator/"

const NUTRITION_INPUT = "EN Моля въведете търсената от вас храна"

const NUTRITION_CONTAINER_SUB_TEXT =
  "EN Изчислете количеството макронутриенти във Вашата храна"
const NUTRITION_CONTAINER_TEXT =
  "EN Разберете какво е количеството калории, което се съдържа в определена порция храна. Получете информация за хранителния състав и определете процентното съотношение на макронутриентите. Научете повече за макронутриентите и защо е важно да знаете състава на храните, които приемате. Разберете какви са най-честите препоръки за хранителните съотношения на някой от основните макронутриенти. И много още ...."
const NUTRITION_CONTAINER_TITE = "EN Хранителен навигатор I"

const NUTRITION_FEATURES_RESORS = "EN Полезни ресурси за"
const NUTRITION_FEATURES_AMOUNT =
  "EN количеството макронутриенти в храните и препоръчителни съотношения при техния прием"
const NUTRITION_FEATURES_HOW_TO = "EN Как да използвате хранителния навигатор?"
const NUTRITION_FEATURES_WHAT_INFO =
  "EN Каква информация ни дава този калкулатор?"
const NUTRITION_FEATURES_READ_MORE = "EN прочети още"
const NUTRITION_FEATURES_MACROS = "EN Какво представляват макронутриентите"
const NUTRITION_FEATURES_IMPORTANT_FOOD =
  "EN Защо е важно да знаете състава на храната?"
const NUTRITION_FEATURES_RECOMENDS =
  "EN Препоръки за хранителните съотношения на макронутриентите"
const NUTRITION_FEATURES_COMMON_FOODS =
  "EN Какви са най-честите препоръки за хранителните съотношения на някой от основните макронутриенти?"
const NUTRITION_FEATURES_RECOMEND_COMBOS =
  "EN Препоръки за хранителните съотношения на макронутриентите"
const NUTRITION_FEATURES_RECOMEND_COMBOS_TIPS =
  "EN Какви са най-честите препоръки за хранителните съотношения намакронутриентите?"

// GL calculator

const GI_CALC_URL_I = "EN /kakvo-predstavlyavat-vglekhidratite/"
const GI_CALC_URL_II = "EN /kak-da-izberete-podkhodyashite-vglekhidratite/"
const GI_CALC_URL_III = "EN /kategoriya-khrakhi-spored-glekimichniya-im-indeks/"
const GI_CALC_URL_IV =
  "EN /dostatchen-li-e-samo-glikemichniyat-indeks-za-da-opredelim-vliyanieto-na/"

const GI_CALC_USEFULL_RES = "EN Полезни ресурси за"
const GI_CALC_CARBS =
  "EN въглехидратите и как да изберете подходящите за Вас въглехидрати"
const GI_CALC_WHAT_ARE_CARBS = "EN Какво представляват въглехидратите?"
const GI_CALC_LEARN_CARBS = "EN Разберете повече за въглехидратите."
const GI_CALC_LEARN_MORE = "EN прочети още"
const GI_CALC_PICK_CARBS = "EN Как да изберете подходящите въглехидратите?"
const GI_CALC_PICK_CARBS_FOR_U =
  "EN Научете повече относно това кои въглехидрати са подходящи за вас."
const GI_CALC_FOOD_CATEG = "EN Категория храни според глекимичния им индекс"
const GI_CALC_HIGH_LOW_GL =
  "EN Научете кои храни имат висок, среден и нисък гликемичен индекс."
const GI_CALC_GL_ENOUGH =
  "EN Достатъчен ли е само гликемичният индекс, за да определим влиянието на въглехидратите, приети чрез храната върху кръвната захар?"
const GI_CALC_IMPORTANT_QUESTION = "EN Намерете отговора на този важен въпрос."

// Calc Page

const CALC_PAGE_WELCOME = "EN Добре дошли!"

const CALC_PAGE_U_ARE_NEW =
  "EN Вие сте с новодиагностициран диабет и не знаете откъде да започнете?"

const CALC_PAGE_U_ARE_OLD =
  "EN Имате дългогодишен захарен диабет и искате по-добър контрол на кръвната захар и теглото?"

const CALC_PAGE_WIGHT_PROBLEMS = "EN Имате проблеми с контрола на килограмите?"

const CALC_PAGE_U_WANT_BETTER_WEIGHT =
  "EN Искате да поддържате здравословен начин на живот и оптимално телесно тегло?"

const CALC_PAGE_CALCS =
  "EN Подбрали сме за Вас едни от най-често използваните онлайн калкулатори за проблеми като захарен диабет, предиабет и наднормено тегло. Тези калкулатори ще Ви помогнат и ако нямате здравословен проблем, а просто искате да сте в доброздраве или да оцените и пресметнете някои метаболитни показатели."

const CALC_PAGE_MAX_HELP =
  "EN Искаме да сме Ви в максимална помощ, за да се справите с едни от най-честите проблеми при захарен диабет тип 2 и затлъстяването– хранителния режим с подбор на подходящи храни и оценка на нуждата от калории спрямо индивидуалните особености. Спрели сме се на няколко базови калкулатора, които нашите здравни експерти считат, чеса в основата на здравословното и балансирано хранене и на борбата с килограмите."

const CALC_PAGE_FIRST_CALC =
  "EN Първият от тях е Калкулаторът за изчисляване на телесната маса."

const CALC_PAGE_FIRST_CALC_TEXT =
  "EN С негова помощ Вие ще научите какъв е Вашият индекс на телесната маса (ИТМ), как може да го използвате за контрола на теглото си, дали този индекс е подходящ при Вас и дали трябва да предприемете някакви мерки, за да оптимизирате теглото си. Какви са рисковете и здравословните проблеми при нисък или висок индекс на телесната маса."

const CALC_PAGE_CAL_CALC =
  "EN Следващият калкулатор ще Ви помогне да изчислите калориите, от които се нуждаете на ден в зависимост от Вашите цели:"

const CALC_PAGE_LOSE_KILOS = "EN да загубите килограми;"

const CALC_PAGE_KEEP_KILOS = "EN да задържите килограмите;"

const CALC_PAGE_GAIN_KILOS = "EN или да качите килограми."

const CALC_PAGE_CAL_CALC_TEXT =
  "EN Но както ще научите и от самия калкулатор, съставът на храните също е от значение за редукцията на телесно тегло. Затова създадохме нашия хранителен навигатор (хранителен навигатор 1 ), с помощта на който ще може да определяте състава на храните – въглехидрати, белтъци, мазнини и колкокалории се съдържат в една порция."

const CALC_PAGE_TEXT_I =
  "EN За хората с проблеми като захарен диабет и предиабет, съставът на въглехидратите е много важен. За тях (а и за всички, които искат да се хранят по този начин) направихме калкулатор, който отчита гликемичния индекс и товар на въглехидратите (хранителен навигатор 2). Те ще Ви помогнат да контролирате по-лесно нивото на кръвната си захар."

const CALC_PAGE_HOW_TO_USE_CALCS =
  "EN В каква последователност да използвате калкулаторите?"

const CALC_PAGE_CALCS_EXPLAIN =
  "EN Няма правилна или грешна последователност за употребата им, също така не е нужно да използвате всички калкулатори. Може да изберете само тези от тях, които са Ви нужни."

const CALC_PAGE_STEPS = "EN Но за улеснение предлагаме следните стъпки:"

const CALC_PAGE_STEP_INDEX = "EN Определете индекса на телесната си маса."

const CALC_PAGE_STEP_CAL = "EN Изчислете дневните калорийни нужди."

const CALC_PAGE_STEP_MACROS =
  "EN Изберете подходяща храна спрямо Вашите индивидуални нужди в съотношение на въглехидрати : белтъци : мазнини, което е съобразено с тях."

const CALC_PAGE_TEXT_II =
  "EN След като сте избрали вида на въглехидрата и неговото количество, проверете гликемичния иднекс и гликемичния товар. Така ще може да изберете въглехидрати, които няма да повишат рязко и за продължителен период от време кръвната захар."

const CALC_PAGE_TEXT_III =
  "EN Тези калкулатори могат да се ползват както от хора със здравословни проблеми, така и от хора, които просто искат дасе погрижат за здравето си, преди да са се сблъскали с някои от най-честите заболявания на нашето съвремие – затлъстяване, метаболитен синдром и захарен диабет тип 2."

const CALC_PAGE_TEXT_IV =
  "EN Ако вече имате някое от тях, не забравяйте да обсъдите показателите си и хранителния режим с диетолог и ендокринолог. Те могат да Ви помогнат и дадат насоки за подходящи групи храни, редукцията на калории и начина на хранене, които да бъдат съобразени с Вашите индивидуални потребности. Така се увеличава възможността да постигнете по-добри и трайни резултати."

const CALC_PAGE_TEXT_V =
  "EN Искаме да сме максимално полезни, затова ще продължим даработим върху изграждането на нови калкулатори, с чиято помощ да се погрижите за здравето си. Ако имате предложения, не се колебайте да се свържете с нас!"

// Sub Form

const SUB_FORM_U_WANT = "EN Искате да водите пълноценен живот?"
const SUB_FORM_DESC =
  "EN Без значение дали сте предпоставени към диабет или сте наскоро ново диагностицирани диабетик, нашите лекари и консултанти са подготвили ръководство което ще ви помогне по пътя за постигане на здрав и пълноценен живот. Предоставената информация е напълно безплатна и е изготвена от водещи специалисти в областта."

// Blog Preview

const BLOG_PREVIEW_FORM_U_WANT = "EN Искаш ли още полезно съдържание?"
const BLOG_PREVIEW_FORM_JOIN_CLUB =
  "EN Включи се в нашия клуб и получи ранен достъп до много"
const BLOG_PREVIEW_FORM_FREE = "EN безплатни"
const BLOG_PREVIEW_FORM_RES = "EN ресурси"
const BLOG_PREVIEW_FORM_SUECURE = "EN 100% сигурност"
const BLOG_PREVIEW_FORM_NO_SPAM = "EN БЕЗ СПАМ"
const BLOG_PREVIEW_FORM_ANON = "EN Запази анонимноста си"
const BLOG_PREVIEW_FORM_PDF = "EN Получаваш PDF ръководство"
const BLOG_PREVIEW_FORM_SIGN_UP = "EN Запиши ме!"

// Specialist Sub

const SPECIALIST_SUB_NAME = "EN Вашето име*"
const SPECIALIST_SUB_EMAIL = "EN Вашият имейл*"
const SPECIALIST_SUB_ABOUT = "EN Относно*"
const SPECIALIST_SUB_MSG = "EN Вашето съобщение"
const SPECIALIST_SUB_ACS =
  "EN С попълването на тази форма вие се съгласявате автоматично с нашите права за ползване"
const SPECIALIST_SUB_TERMS = "EN политика за поверителност."
const SPECIALIST_SUB_TEAM =
  "EN Екипа ни ще се постарае да отговори възможно най-бързо на вашето запитване."
const SPECIALIST_SUB_SEND = "EN Изпрати запитването"
const SPECIALIST_SUB_AND = "EN и"
const SPECIALIST_SUB_USE_TERMS = "EN права за ползване"
const SPECILIST_SUB_ABOUT = "EN Относно*"
const SPECILIST_SUB_WRAPPER = "EN Свържете се с специалист"

// SEO

const BLOG_META_TITLE = "Blog"
const BLOG_META_DESCRIPTION =
  "Dianurse blog represents the ins and outs of life with diabetes. We offer first-person stories, latest news, tips, recipes and much more."
const BMI_CALCULATOR_META_TITLE = "BMI-Calculator"
const BMI_CALCULATOR_META_DESCRIPTION =
  "Learn all about BMI directly from our health experts - calculate your BMI and find out what our ideal weight is - and much more .."
const CALCULATORS_PAGE_META_TITLE = "Calculators"
const CALCULATORS_PAGE_META_DESCRIPTION = "Calculators"
const CALORIE_CALCULATOR_META_TITLE = "Calorie calculator"
const CALORIE_CALCULATOR_META_DESCRIPTION =
  "Learn all about calories directly from our health experts - how our bodies use calories, how to calculate the calories we need and much more ..."
const CONTACTS_PAGE_META_TITLE = "Contacts"
const CONTACTS_PAGE_META_DESCRIPTION = "Contacts"
const FIRST_STEPS_META_TITLE = "First steps"
const FIRST_STEPS_META_DESCRIPTION = "First steps"
const FOR_DIABETICS_META_TITLE = "For Diabetics"
const FOR_DIABETICS_META_DESCRIPTION =
  "Dianurse offers a set of FREE tools, calculators and estimators to support people with diabetes to better understand their condition."
const FOR_HEALTH_COACH_META_TITLE = "For Health Coach"
const FOR_HEALTH_COACH_META_DESCRIPTION =
  "Dianurse is a tele-health platform and your single source for acquiring additional private patients and delivering them individualized care plans."
const GL_CALCULATOR_META_TITLE = "Gl Calculator"
const GL_CALCULATOR_META_DESCRIPTION =
  "Learn all about carbohydrates. Calculate the glycemic index and the glycemic load of foods you consume through our food navigator."
const HOME_PAGE_META_TITLE = "Home"
const HOME_PAGE_META_DESCRIPTION =
  "At Dianurse, we're transforming diabetes care. Our tele-health solution eliminates any location barrier and delivers most effective care plans."
const NUTRITION_CALCULATOR_META_TITLE = "Nutrition Calculator"
const NUTRITION_CALCULATOR_META_DESCRIPTION = "Nutrition Calculator"
const SPECIALIST_SUBSCRIPTION_META_TITLE = "Contact with expert"
const SPECIALIST_SUBSCRIPTION_META_DESCRIPTION = "Contact with expert"
const SUBSCRIPTION_META_TITLE = "Subscription"
const SUBSCRIPTION_META_DESCRIPTION = "Subscription"

export default {
  CONTACT_WITH_EXPERT_URL_I,
  CONTACT_WITH_EXPERT_URL_II,
  WHICH_SENTENCE_BEST_DESCRIBES_YOUR_DAILY_ACTIVITY_LEVEL,
  DIABETICS_HIW_DIABETICS_HIW_TRANSPARANCY_TEXT,
  WHICH_MATCHES_YOUR_LEVEL_OF_PHYSICAL_ACTIVITY,
  HLTH_COACH_KEY_FEATURES_FOLLOW_INOVATIONS,
  HLTH_COACH_TRAINING_ONLINE_COUNSULTATION,
  NUTRITION_FEATURES_RECOMEND_COMBOS_TIPS,
  HLTH_COACH_KEY_FEATURES_ONLINE_CALENDAR,
  HLTH_COACH_KEY_FEATURES_WORK_FROM_HOME,
  HLTH_COACH_KEY_FEATURES_INOVATION_TEXT,
  HLTH_COACH_TRAINING_CONSULTATION_TEXT,
  HLTH_COACH_KEY_FEATURES_KEY_FEATURES,
  HLTH_COACH_KEY_FEATURES_YOU_ARE_TEXT,
  INDEX_HLTH_LIFE_FIRST_STEPS_BTR_LIFE,
  RECOMMENDATION_OVER_34_9_UNDER_39_9,
  RECOMMENDATION_OVER_29_9_UNDER_34_9,
  RECOMMENDATION_OVER_24_9_UNDER_29_9,
  RECOMMENDATION_OVER_18_5_UNDER_24_9,
  NUTRITION_FEATURES_RECOMEND_COMBOS,
  NUTRITION_FEATURES_IMPORTANT_FOOD,
  HLTH_COACH_TRAINING_SCHEDULE_TEXT,
  INDEX_CALC_INFO_WHATS_BEST_WEIGHT,
  FOODS_WITH_GLYCEMIC_INDEX_BETWEEN,
  CAL_CALC_FEAT_LEARN_HOW_MUCH_CAL,
  HLTH_COACH_KEY_FEATURES_CAL_TEXT,
  HLTH_COACH_TRAINING_CONSULTATION,
  DIABETICS_HLP_SECTION_HEALTH_PRO,
  INDEX_CALC_INFO_DAILY_CAL_INTAKE,
  FOODS_WITH_GLYCEMIC_LOAD_BETWEEN,
  NUTRITION_FEATURES_COMMON_FOODS,
  HLTH_COACH_KEY_FEATURES_YOU_ARE,
  HLTH_COACH_HELP_REACH_THE_WORLD,
  HLTH_COACH_TRAINING_INCOME_TEXT,
  DIABETICS_HIW_ALWAYS_IN_CONTACT,
  FIRST_STEPS_FORM_READ_AND_AGREE,
  FIRST_STEPS_FORM_PRIVACY_POLICY,
  ADVICES_FOR_HEALTHY_LIFE_BUTTON,
  CALC_PAGE_U_WANT_BETTER_WEIGHT,
  DIABETICS_NEWSLTTR_HOW_TO_PICK,
  DIABETICS_APP_TRANSPARENT_TEXT,
  HOME_CONSULT_DESC_CONSULTATION,
  INDEX_DIABETES_DIAGNOSED_COUNT,
  FIRST_STEPS_FORM_YES_SUBSCRIBE,
  CALORIE_CALCULATOR_DESCRIPTION,
  HLTH_COACH_FEAT_FASTER_BETTER,
  HLTH_COACH_FEAT_TRUE_FEEDBACK,
  DIABETICS_APP_CONVENIENT_TEXT,
  DIABETICS_OC_EASY_SECURE_FAST,
  DIABETICS_HLP_SECTION_SIGN_UP,
  HOME_CONSULT_DESC_ONEHUND_PRO,
  INDEX_DIABETES_AFFECTED_COUNT,
  NUTRITION_FEATURES_WHAT_INFO,
  NUTRITION_FEATURES_READ_MORE,
  NUTRITION_FEATURES_RECOMENDS,
  NUTRITION_CONTAINER_SUB_TEXT,
  CAL_CALC_FEAT_LEARN_WHAT_CAL,
  CAL_CALC_FEAT_LEARN_CAL_BURN,
  HLTH_COACH_KEY_FEATURES_TEXT,
  HLTH_COACH_PRICE_TALK_IN_NUM,
  HLTH_COACH_PRICE_PRECENT_III,
  HLTH_COACH_TRAINING_SCHEDULE,
  DIABETICS_NEWSLTTR_FREE_TIPS,
  DIABETICS_NEWSLTTR_SUBSCRIBE,
  HOME_CONSULT_DESC_SPEC_OFFER,
  INDEX_CALC_REWIEW_IVET_STORY,
  INDEX_HLTH_LIFE_HEALTHY_LIFE,
  STANDING_ABOUT_HALF_THE_TIME,
  BLOG_PREVIEW_FORM_JOIN_CLUB,
  HLTH_COACH_PRICE_PRECENT_II,
  HLTH_COACH_PRICE_PRECENT_IV,
  HLTH_COACH_FEAT_REACH_WORLD,
  DIABETICS_APP_INDV_SEG_TEXT,
  INDEX_CALC_REWIEW_JAY_STORY,
  INDEX_CALC_INFO_FOOD_U_NEED,
  INDEX_CALC_INFO_FOOD_NAV_II,
  INDEX_HLTH_LIFE_U_WANT_LEAD,
  WALKING_ABOUT_HALF_THE_TIME,
  TRY_CALCULATOR_AGAIN_BUTTON,
  CALC_PAGE_HOW_TO_USE_CALCS,
  GI_CALC_IMPORTANT_QUESTION,
  CAL_CALC_FEAT_HOW_MUCH_CAL,
  HLTH_COACH_PRICE_PRECENT_I,
  HLTH_COACH_HELP_LEARN_MORE,
  HLTH_COACH_TRAINING_INCOME,
  HLTH_COACH_HEADER_FREE_ACS,
  DIABETICS_APP_NO_CASH_TEXT,
  DIABETICS_HIW_TRANSPARANCY,
  DIABETICS_HLP_SECTION_TEXT,
  INDEX_CALC_REWIEW_YI_STORY,
  INDEX_CALC_INFO_GLIC_INDEX,
  INDEX_CALC_INFO_FOOD_NAV_I,
  FIRST_STEPS_PLS_ACPT_TERMS,
  DAILY_RECOMMENDED_CALORIES,
  BLOG_PREVIEW_FORM_SUECURE,
  BLOG_PREVIEW_FORM_NO_SPAM,
  BLOG_PREVIEW_FORM_SIGN_UP,
  CALC_PAGE_FIRST_CALC_TEXT,
  NUTRITION_FEATURES_RESORS,
  NUTRITION_FEATURES_AMOUNT,
  NUTRITION_FEATURES_HOW_TO,
  NUTRITION_FEATURES_MACROS,
  HLTH_COACH_PRICE_TIN_TEXT,
  HLTH_COACH_PRICE_III_TEXT,
  HLTH_COACH_HELP_DR_HRISTO,
  HLTH_COACH_FEAT_AUTO_WORK,
  DIABETICS_APP_GET_TO_KNOW,
  DIABETICS_APP_TRANSPARENT,
  DIABETICS_APP_SECURE_TEXT,
  HOME_CONSULT_DESC_MED_PRO,
  HOME_CONSULT_DESC_NO_SPAM,
  INDEX_DIABETES_SUGAR_DEAD,
  INDEX_DIABETES_DEAD_COUNT,
  INDEX_CALC_REWIEW_URL_III,
  INDEX_CALC_TOOLS_FOR_HELP,
  INDEX_CALC_INFO_FOUR_FREE,
  FIRST_STEPS_FORM_UR_EMAIL,
  FIRST_STEPS_PLS_VAL_EMAIL,
  RECOMMENDATION_UNDER_18_5,
  SPECIALIST_SUB_USE_TERMS,
  BLOG_PREVIEW_FORM_U_WANT,
  CALC_PAGE_WIGHT_PROBLEMS,
  GI_CALC_PICK_CARBS_FOR_U,
  NUTRITION_CONTAINER_TEXT,
  NUTRITION_CONTAINER_TITE,
  CAL_CALC_FEAT_CAL_INTAKE,
  CAL_CALC_FEAT_LEARN_MORE,
  HLTH_COACH_PRICE_II_TEXT,
  HLTH_COACH_PRICE_IV_TEXT,
  HLTH_COACH_HELP_HELP_PPL,
  HLTH_COACH_FEAT_NEW_PACI,
  HLTH_COACH_FEAT_SCHEDULE,
  HLTH_COACH_HEADER_PROFIT,
  DIABETICS_APP_CONVENIENT,
  DIABETICS_OC_EASY_ACCESS,
  DIABETICS_HIW_EASY_STEPS,
  INDEX_DIABETES_DIAGNOSED,
  INDEX_CALC_REWIEW_URL_II,
  INDEX_CALC_INFO_CAL_CALC,
  INDEX_CALC_INFO_SEE_MORE,
  FIRST_STEPS_FORM_UR_NAME,
  CALORIE_CALCULATOR_TITLE,
  RECOMMENDATION_OVER_39_9,
  INPUT_SEARCH_PLACEHOLDER,
  INDEX_BLOG_WRPR_HLP_FR_U,
  CALC_PAGE_CAL_CALC_TEXT,
  CALC_PAGE_CALCS_EXPLAIN,
  BMI_FEAT_PERFECT_WEIGHT,
  HLTH_COACH_PRICE_I_TEXT,
  DIABETICS_NEWSLTTR_FREE,
  DIABETICS_NEWSLTTR_TIPS,
  DIABETICS_APP_EASY_TEXT,
  DIABETICS_HIW_PIC_A_PRO,
  INDEX_HERO_HERE_TO_HELP,
  INDEX_HERO_NEW_DIAGNOSE,
  INDEX_DIABETES_AFFECTED,
  INDEX_CALC_REWIEW_URL_I,
  FIRST_STEPS_RM_TNX_BETA,
  FIRST_STEPS_FORM_SUBMIT,
  BLOG_PREVIEW_FORM_FREE,
  BLOG_PREVIEW_FORM_ANON,
  GI_CALC_WHAT_ARE_CARBS,
  CAL_CALC_FEAT_WHAT_CAL,
  CAL_CALC_FEAT_CAL_BURN,
  BMI_FEAT_EXSAMPLE_EASY,
  HLTH_COACH_HELP_PROFIT,
  HLTH_COACH_FEAT_ONLINE,
  HLTH_COACH_HEADER_DESC,
  DIABETICS_APP_INDV_SEG,
  DIABETICS_OC_SYNC_TEXT,
  DIABETICS_HIW_AIC_TEXT,
  DIABETICS_HIW_PAP_TEXT,
  HOME_CONSULT_DESC_TEXT,
  HOME_CONSULT_DESC_FREE,
  HOME_CONSULT_DESC_ANON,
  INDEX_HERO_FIRST_STEPS,
  INDEX_CALC_REWIEW_IVET,
  FIRST_STEPS_FORM_TERMS,
  FIRST_STEPS_RM_TNX_MSG,
  AVERAGE_GLYCEMIC_INDEX,
  SEATED_MOST_OF_THE_DAY,
  CONSTANTLY_ON_THE_MOVE,
  SPECILIST_SUB_WRAPPER,
  BLOG_PREVIEW_FORM_RES,
  BLOG_PREVIEW_FORM_PDF,
  CALC_PAGE_STEP_MACROS,
  CAL_CALC_FEAT_USEFULL,
  BMI_FEAT_USE_EFECTIVE,
  DIABETICS_APP_NO_CASH,
  DIABETICS_OC_ESF_TEXT,
  HOME_CONSULT_DESC_PDF,
  INDEX_HERO_FREE_GUIDE,
  INDEX_CALC_REWIEW_JAY,
  INDEX_CALC_TOOLS_DESC,
  SPECIALIST_SUB_EMAIL,
  SPECIALIST_SUB_ABOUT,
  SPECIALIST_SUB_TERMS,
  CALC_PAGE_FIRST_CALC,
  CALC_PAGE_LOSE_KILOS,
  CALC_PAGE_KEEP_KILOS,
  CALC_PAGE_GAIN_KILOS,
  CALC_PAGE_STEP_INDEX,
  BMI_FEAT_WHAT_IS_ITM,
  BMI_HEADER_MAIN_TEXT,
  HLTH_COACH_FEAT_RATE,
  DIABETICS_APP_SECURE,
  DIABETICS_OC_EA_TEXT,
  DIABETICS_OC_SIGN_UP,
  INDEX_DIABETES_SUGAR,
  INDEX_CALC_REWIEW_YI,
  INDEX_HLTH_LIFE_DESC,
  INDEX_CALC_INFO_FREE,
  FIRST_STEPS_FORM_AND,
  SPECILIST_SUB_ABOUT,
  SPECIALIST_SUB_NAME,
  SPECIALIST_SUB_TEAM,
  SPECIALIST_SUB_SEND,
  CALC_PAGE_U_ARE_NEW,
  CALC_PAGE_U_ARE_OLD,
  GI_CALC_USEFULL_RES,
  GI_CALC_LEARN_CARBS,
  GI_CALC_HIGH_LOW_GL,
  CAL_CALC_FEAT_TYPES,
  CAL_CALC_FEAT_SORCE,
  BMI_FEAT_HOW_TO_ITM,
  BMI_FEAT_HOW_TO_USE,
  HLTH_COACH_HELP_DOC,
  INDEX_DIABETES_DESC,
  INDEX_DIABETES_DEAD,
  INDEX_CALC_INFO_BMI,
  FIRST_STEPS_FORM_FS,
  FIRST_STEPS_REQ_FLD,
  SLIDER_VALUE_2_TEXT,
  SLIDER_VALUE_0_TEXT,
  WHAT_IS_YOUR_HEIGHT,
  WHAT_IS_YOUR_WEIGHT,
  CONTACT_WITH_EXPERT,
  MORE_ADVICES_BUTTON,
  WHAT_IS_YOUR_GENDER,
  HIGH_GLYCEMIC_INDEX,
  SLIDER_VALUE_1_TEXT,
  SPECIALIST_SUB_AND,
  SPECIALIST_SUB_MSG,
  SPECIALIST_SUB_ACS,
  CALC_PAGE_MAX_HELP,
  CALC_PAGE_CAL_CALC,
  CALC_PAGE_STEP_CAL,
  CALC_PAGE_TEXT_III,
  GI_CALC_LEARN_MORE,
  GI_CALC_PICK_CARBS,
  GI_CALC_FOOD_CATEG,
  BMI_FEAT_READ_MORE,
  BMI_FEAT_ITM_FLAWS,
  DIABETICS_APP_DESC,
  DIABETICS_APP_EASY,
  FOOTER_ABOUT_COMNY,
  FOOTER_HELP_CENTRE,
  FOOTER_DOC_NETWORK,
  INDEX_CALC_STORIES,
  HEADER_CALCULATORS,
  LOW_GLYCEMIC_INDEX,
  GET_RESULTS_BUTTON,
  TABS_SECTION_TITLE,
  FOOD_SEARCH_BUTTON,
  GLYCEMIC_INDEX_TAB,
  PAGE_NOT_HOME_PAGE,
  INPUT_SEARCH_TITLE,
  NUTRITION_URI_III,
  CALC_PAGE_WELCOME,
  CALC_PAGE_TEXT_II,
  CALC_PAGE_TEXT_IV,
  GI_CALC_GL_ENOUGH,
  CAL_CALC_SUB_TEXT,
  CAL_CALC_FEAT_QAL,
  BMI_FEAT_EXSAMPLE,
  DIABETICS_OC_SYNC,
  FOOTER_CONTACT_US,
  GLYCEMIC_INDEX_OF,
  GLYCEMIC_LOAD_TAB,
  NUTRITION_URI_II,
  NUTRITION_URI_IV,
  CAL_CALC_URL_III,
  BMI_FEAT_URL_III,
  CALC_PAGE_TEXT_I,
  CALC_PAGE_TEXT_V,
  GL_CALC_SUB_TEXT,
  FOOTER_DIABETICS,
  GLYCEMIC_LOAD_OF,
  RECOMMENDED_TEXT,
  WHAT_IS_YOUR_AGE,
  CALCULATE_BUTTON,
  NUTRITION_URI_I,
  GI_CALC_URL_III,
  CAL_CALC_URL_II,
  CAL_CALC_URL_IV,
  BMI_FEAT_URL_II,
  BMI_FEAT_URL_IV,
  SUB_FORM_U_WANT,
  CALC_PAGE_CALCS,
  CALC_PAGE_STEPS,
  BLOG_CATEGORIES,
  NUTRITION_INPUT,
  BMI_FEAT_MESURE,
  BMI_HEADER_MASS,
  BMI_HEADER_CALC,
  FOOTER_ABOUT_US,
  FOOTER_SERVICES,
  FOOTER_PODCASTS,
  HEADER_DIABETIC,
  GI_CALC_URL_II,
  GI_CALC_URL_IV,
  CAL_CALC_URL_I,
  BMI_FEAT_URL_I,
  NUTRITION_TEXT,
  CAL_CALC_TITLE,
  BLOG_MOST_READ,
  FOOTER_CARIERS,
  FOOTER_PRIVACY,
  FOOTER_COOKIES,
  HEADER_DOCTORS,
  PAGE_NOT_FOUND,
  PER_SERVING_OF,
  SLIDER_VALUE_1,
  SLIDER_VALUE_2,
  SLIDER_VALUE_0,
  GI_CALC_URL_I,
  SUB_FORM_DESC,
  GI_CALC_CARBS,
  GL_CALC_TITLE,
  CAL_CALC_TEXT,
  BMI_EMAIL_SCS,
  BMI_EMAIL_INV,
  BMI_EMAIL_USD,
  DIABETICS_HIW,
  CARBOHYDRATES,
  SECTION_TITLE,
  GL_CALC_TEXT,
  BMI_FEAT_RES,
  FOOTER_LEGAL,
  FOOTER_TERMS,
  FOOTER_TOOLS,
  FOOTER_HELP,
  FOOTER_BLOG,
  HEADER_BLOG,
  HEADER_MAIN,
  YEARS_POPUP,
  FOOTER_FAQ,
  FEET_POPUP,
  FOOD_DRINK,
  BLOG_NEW,
  LBS_INCH,
  KG_POPUP,
  SM_POPUP,
  LB_POPUP,
  MY_UNITS,
  IMPERIAL,
  BMI_BMI,
  GLUCOSE,
  PORTION,
  METRIC,
  FEMALE,
  HEIGHT,
  WEIGHT,
  KG_BMI,
  YEARS,
  KG_CM,
  MALE,
  INCH,
  GRAM,
  FEET,
  LBS,
  CM,
  GI,
  SM,
  GL,
  KG,
  LB,
}
